import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface VersandkostenState extends BasePageState {}
interface VersandkostenModel {}

export default class VersandkostenPage extends Basepage<
  VersandkostenState,
  VersandkostenModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="versandkosten">
        <h1>Porto-Konditionen</h1>
        <table>
          <tbody>
            <tr>
              <th style={{ textAlign: 'left' }}>Produkt</th>
              <th>netto Preis</th>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>Großbrief bis 500g</td>
              <td style={{ textAlign: 'right' }}>1,80 €*</td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>Kleinpaket bis 1kg</td>
              <td style={{ textAlign: 'right' }}>2,75 €*</td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>DHL-Paket bis 1kg</td>
              <td style={{ textAlign: 'right' }}>3,91 €*</td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>DHL-Paket bis 3kg</td>
              <td style={{ textAlign: 'right' }}>4,01 €*</td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>DHL-Paket bis 5kg</td>
              <td style={{ textAlign: 'right' }}>5,35 €*</td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>DHL-Paket bis 10kg</td>
              <td style={{ textAlign: 'right' }}>6,46 €*</td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left' }}>DHL-Paket bis 31,5kg</td>
              <td style={{ textAlign: 'right' }}>9,35 €*</td>
            </tr>
          </tbody>
        </table>
        <br />
        <span>
          * Die angegebenen Preise sind netto Preise, sie beinhalten jedoch
          bereits, sofern es anfällt, den Maut- und Energiekostenzuschlag sowie
          den Peakzuschlag im November und Dezember.
          <br />
          <br />
          Zu jeder Sendung kommen Handlingkosten in Höhe von 0,75 € hinzu. Die
          Verpackungskosten sind darin bereits enthalten.
          <br />
          <br />
          <b>Die Portokosten werden je Sendung an Sie berechnet.</b> Bitte
          nehmen Sie daher unbedingt noch die Einstellung der Versandtage in
          Ihrem{' '}
          <a href="http://www.buchbutler.de/konto/settings" target="_blank">
            Kundenkonto
          </a>{' '}
          vor.
        </span>
        {/* 
        <b>Versandkosten</b>
        <br />
        <br />
        Für Firmenkunden/Behörden gelten folgende Bedingungen:
        <br />
        <br />
        Artikel, welche mit der Markierung <b>Portofrei</b> gekennzeichnet sind,
        liefern wir Ihnen Versandkostenfrei.
        <br />
        <br />
        <br />
        Für Buchhändler gelten folgende Bedingungen:
        <br />
        <br />
        Die Portokosten unterscheiden sich Variabel bei jedem Artikel.
        <br />
        Der maximale Wert der Portokosten beträgt 3,81 € Netto.
        <br />
        <br />
        Die genannten Preise gelten nur für Lieferungen innerhalb Deutschlands,
        bei Auslandslieferungen können diese von den Angaben abweichen.
        <br />
        Bei Fragen finden Sie unsere Kontaktdaten im Impressum.
        */}
      </div>
    );
  }
  initState(base: BasePageState): VersandkostenState {
    let newState: VersandkostenState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Versandkosten';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Versandkosten</span>;
  }
  getType(): string {
    return 'VersandkostenPage';
  }
}
